import React, { useEffect, useState } from "react";
import { useUser } from "../../context/UserContext";
import { useTranslation } from "react-i18next";
import { Hostage, Story } from "../types";
import feedEmpty from "../../icons/feed-empty.svg";
import StoryCard from "../Feed/StoryCard";

interface UserEventsProps {
  allHostages: Hostage[];
}

async function fetchUsersLastStories(): Promise<Story[]> {
  const url = `/api/story/allRecent`;

  try {
    const response = await fetch(url, {
      credentials: "include", // Include cookies in the request
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      console.error(`Failed to fetch uers stories : ${response.status}`);
      return [];
    }
  } catch (error) {
    console.error("Error fetching All-User-Stories data:", error);
    return [];
  }
}

const UserFeed: React.FC<UserEventsProps> = ({ allHostages: allHostages }) => {
  const [loading, setLoading] = useState(true);
  const [usersStories, setUsersStories] = useState<Story[]>([]);
  const { t, i18n } = useTranslation();
  const { user } = useUser();

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      const fetchedUsersStories = await fetchUsersLastStories();
      setUsersStories(fetchedUsersStories);
      setLoading(false);
    };
    fetchAll();
  }, [i18n.language]);
  
  if (!user) {
    return null;
  }

  if (loading) {
    return <div>Loading Stories...</div>;
  }

  if (!usersStories || usersStories.length === 0) {
    return <div style={{ textAlign: "center" }}>
      <img src={feedEmpty} alt="No Posts" style={{ display: "block", margin: "30px auto" }} />
      <h1 style={{ fontSize: "1.5em" }}>{t("userFeed.emptyTitle")}</h1>
      <p>{t("userFeed.emptySubtitle")}</p>
    </div>;
  }

  function getHostageById(hostageId: string) {
    return allHostages.find(hostage => hostage.id === hostageId);
  }

  return (
    <div
      style={{ maxWidth: "800px", margin: "0 auto", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div className="stories-container">
        {usersStories?.map((story, index) => {
          const hostage = getHostageById(story.hostage);

          if (!hostage) return null;

          return (
            <React.Fragment key={story.id}>
              <StoryCard
                story={story}
                hostage={hostage}
              />
              {index !== usersStories.length - 1 && <hr className="story-separator" />}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default UserFeed;